var React = require('react');

function CgmPoints (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"10.5","cy":"49.6","rx":"10.5","ry":"10.5","key":0}),React.createElement("ellipse",{"cx":"69.5","cy":"10.5","rx":"10.5","ry":"10.5","key":1}),React.createElement("path",{"d":"M13.4 49.6c0-5.5 1.1-14.2 4.8-20.3 2.1-3.5 5.1-6.1 9.5-6.1 2.7 0 4.6 1.4 6.2 3.2 1.3 1.5 2.5 3.4 3.6 5.2 3.6 5.8 7.5 11.2 14.8 11.2 6 0 10.6-3.6 13.9-8.9 4.4-7.1 6.3-17.1 6.3-23.4 0-1.6-1.3-2.9-2.9-2.9 -1.6 0-2.9 1.3-2.9 2.9 0 5.5-1.6 14.2-5.4 20.3 -2.1 3.5-5 6.1-8.9 6.1 -2.7 0-4.6-1.4-6.2-3.2 -1.3-1.5-2.5-3.4-3.6-5.2 -3.6-5.8-7.5-11.2-14.8-11.2 -6.7 0-11.4 3.7-14.6 9 -4.2 7-5.6 17.1-5.6 23.4 0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9Z","key":2})]);
}

CgmPoints.defaultProps = {"width":"80","height":"60","viewBox":"0 0 80 60","strokeLinejoin":"round"};

module.exports = CgmPoints;

CgmPoints.default = CgmPoints;
